export enum SearchDisplayMode {
  HIGHLIGHT = "highlight",
  FILTER = "filter"
}

export enum SearchType {
  SEMANTIC = "semantic",
  NORMAL = "normal"
}

export type TCanvasOptions = {
  granularity: number,
  minAccuracy: number,
  maxAccuracy: number,
  searchText: string,
  expandOthersNode: boolean,
  nodeDistance: number,
  nodeRepulsion: number,
  showDQ: boolean,
  searchType: SearchType;
  searchDisplayMode: SearchDisplayMode;
  filterItems: number[] | null;
  maxShowingColumnCount: number | null
  hiddenList: string[] //list of node_ids to be hidden
}
